import _ from 'lodash';

let store = sessionStorage;

let browserCheck = () => {
  if (_.isNil(store)) {
    console.log('This browser does not support this application');
  }
};

browserCheck();

export let clearAll = () => {
  store.clear();
};

export let remove = (key) => {
  if (!_.isNil(key)) {
    store.removeItem(key);
  } else {
    console.log('to get a value, please provide a key');
  }
};

export let setValue = (key, value) => {
  let itemString;

  if (!_.isNil(key) && typeof key === 'string' && !_.isNil(value)) {
    itemString = JSON.stringify(value);
    store.setItem(key, itemString);
  } else {
    console.log(
      `to set a value, the key, ${key}, must exist and be of type 'string', and the value, ${value}, must exist, use remove(key) to erase a value`
    );
  }
};

export let getValue = (key) => {
  let itemString;
  let itemObj = {};

  if (!_.isNil(key)) {
    itemString = store.getItem(key);
    try {
      itemObj = JSON.parse(itemString);
      if (_.isNil(itemObj)) {
        return null;
      }
      return itemObj;
    } catch (e) {
      console.log(`value, ${itemString}, for key, ${key}, in store is corrupted: \n ${e.toString()}`);
    }
  } else {
    console.log('to get value, the key must exist');
  }
};

export default {
  clearAll,
  remove,
  getValue,
  setValue,
};
